export class ItemUnitMiniEntity {
  id?: number;
  isActive?: boolean;
  title?: string | null;
}
